import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import type { AppModalTone } from "@/components/ui/app-confirm-modal";
import { AlertTriangle, CheckCircle2, Info, XCircle } from "lucide-react";

interface AppFeedbackModalProps {
  open: boolean;
  title: string;
  description?: string;
  tone?: AppModalTone;
  confirmText?: string;
  onClose: () => void;
}

const toneStyles: Record<AppModalTone, string> = {
  info: "text-sky-600",
  success: "text-emerald-600",
  warning: "text-amber-600",
  error: "text-destructive",
};

function ToneIcon({ tone = "info" }: { tone?: AppModalTone }) {
  if (tone === "success")
    return <CheckCircle2 className={`h-5 w-5 ${toneStyles[tone]}`} />;
  if (tone === "warning")
    return <AlertTriangle className={`h-5 w-5 ${toneStyles[tone]}`} />;
  if (tone === "error")
    return <XCircle className={`h-5 w-5 ${toneStyles[tone]}`} />;
  return <Info className={`h-5 w-5 ${toneStyles[tone]}`} />;
}

export function AppFeedbackModal({
  open,
  title,
  description,
  tone = "info",
  confirmText = "Aceptar",
  onClose,
}: AppFeedbackModalProps) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-foreground">
            <ToneIcon tone={tone} />
            <span>{title}</span>
          </DialogTitle>
          <DialogDescription className={description ? undefined : "sr-only"}>
            {description ?? "Diálogo de la aplicación."}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" onClick={onClose}>
            {confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
